import React, {useState, createContext, useEffect} from 'react';
import './index.css';
import theme from './theme';

import Home from './pages/Home';
import Login from './pages/login';
import RegistFond from './pages/register-fond';
import RegistDepense from './pages/register-depense';
import Cloture from './pages/cloture';
import Rapport from './pages/rapport';
import RapportAnnuel from './pages/rapport-annuel';
import GrandLivre from './Components/journaux/grand-livre';
import JrnDon from './Components/journaux/jrn-don';
import JrnDonInterEglise from './Components/journaux/jrn-don-inter-eglise';
import JrnVers from './Components/journaux/jrn-versement';
import DonatorManager from './pages/donator-manager';
import Cerfa from './pages/cerfa';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CompteManager from './pages/compte-manager';
import JrnDepenses from './Components/journaux/jrn-depense';
import JrnPetiteCaisse from './Components/journaux/jrn-pc';
import JrnVirement from './Components/journaux/jrn-virement';
import JrnDepartement from './Components/journaux/jrn-department';
import JrnComptes from './Components/journaux/jrn-comptes';
import Users from './AdmComponents/users';
import Eglises from './AdmComponents/eglises';
import MdpForm from './pages/reinit-mdp';
import VersementsManager from './AdmComponents/versement-cash';
import VersementsBanqueManager from './AdmComponents/versement-banque';
import CaisseCenter from './AdmComponents/caisse-center';
import CaisseRecette from './AdmComponents/caisse-recette';
import VerseForm from './pages/verse-form';
import DBManager from './AdmPages/db-manager';
import EBPexport from './AdmComponents/EBP-export';
import AlerteManager from './AdmPages/alerte-manager';
import RegionsManager from './AdmPages/regions-manager';
import LogManager from './AdmPages/log-manager';
import DepensesCourantes from './pages/depenses-courantes'
import Fournisseurs from './pages/fournisseurs';
// import Abonnements from './pages/abonnements';

import { API } from './conf';

//dark mode et proposition de palette de couleur(en fonction du mode)

export const Context = createContext()

const routes = [
  {path:"/recettes/enregistrement-des-fonds", element: <RegistFond/>},
  {path:"/versements/enregistrement", element: <VerseForm/>},
  {path:"/depenses/enregistrement", element: <RegistDepense/>},

  {path:"/cloture", element: <Cloture/>},
  {path:"/rapports", element: <Rapport/>},
  {path:"/rapports/annuel", element: <RapportAnnuel/>},

  {path:"/journal/global", element: <GrandLivre/>},
  {path:"/journal/dons", element: <JrnDon/>},
  {path:"/journal/dons-inter-eglise", element: <JrnDonInterEglise/>},
  {path:"/journal/versements", element: <JrnVers/>},
  {path:"/journal/depenses", element: <JrnDepenses/>},
  {path:"/journal/petite-caisse", element: <JrnPetiteCaisse/>},
  {path:"/journal/virements", element: <JrnVirement/>},
  {path:"/journal/départements", element: <JrnDepartement/>},
  {path:"/comptes/consultation", element: <JrnComptes/>},

  {path:"/comptes", element: <CompteManager/>},
  {path:"/donateurs", element: <DonatorManager/>},
  {path:"/cerfa", element: <Cerfa/>},
  {path:"/users", element: <Users/>},
  {path:"/eglises", element: <Eglises/>},
  {path:"/regions", element: <RegionsManager/>},
  {path:"/dada-base", element: <DBManager/>},

  {path:"/export/ebp", element: <EBPexport/>},
  {path:"/alertes", element: <AlerteManager/>},
  {path:"/logs", element: <LogManager/>},

  {path:"/set-password/:token", element: <MdpForm/>},

  {path:"/caisse/versements", element: <VersementsManager/>},
  {path:"/caisse", element: <CaisseCenter/>},
  {path:"/caisse/recette", element: <CaisseRecette/>},

  {path:"/versements/banque", element: <VersementsBanqueManager/>},

  {path:"/depenses/courantes", element: <DepensesCourantes/>},
  // {path:"/depenses/abonnements", element: <Abonnements/>},
  {path:"/fournisseurs", element: <Fournisseurs/>},
]

const unlogged_router = createBrowserRouter([
    {path:"/", element: <Login/>},
    {path:"/set-password/:token", element: <MdpForm/>},
    {path:"*", element: <Login/>}
  ])

export default function App() {
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [isConnect, setConnect] = useState(sessionStorage.getItem("token") ? true : false)
  const [eglise, seteglise] = useState(sessionStorage.getItem('eglise')?JSON.parse(sessionStorage.getItem('eglise')):'')
  const [region, setRegion] = useState(sessionStorage.getItem('region')?JSON.parse(sessionStorage.getItem('region')):'')
  const [exercice, setExercice] = useState(sessionStorage.getItem('exercice')?parseInt(sessionStorage.getItem('exercice')):'')
  const [exercices, setExercices] = useState(sessionStorage.getItem('exercices')?JSON.parse(sessionStorage.getItem('exercices')):[])

  function updateConnect(newValue) {
    setConnect(newValue)
  }

  function setEglise(value) {
    seteglise(value)
    sessionStorage.setItem('eglise', value==='indifferent' ? sessionStorage.getItem('original_eglise') : JSON.stringify(value))
  }

  const getExercices = (query) => {
    fetch(API.concat('/exercices/annees'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token')
      }, body: JSON.stringify(query)
    }).then(async response => {
      const token = response.headers.get('x-auth-token');
      if (response.status === 401) {
        sessionStorage.clear();
        updateConnect(false);
      } else {
        if (token && token !== sessionStorage.getItem('token') && token !== '') {
          sessionStorage.setItem('token', response.headers.get('x-auth-token'));
        }
        if (response.status === 200) {
          const json = await response.json(); console.log(json);
          setExercices(json);
          if((!!exercice && json.length>0)|| !json.includes(exercice)){
            setExercice(json[0]); 
            sessionStorage.setItem('exercice', JSON.stringify(json[0]));
            sessionStorage.setItem('exercices', JSON.stringify(json));
          }
        }
      }
    })
  }

  useEffect(()=>{
    if(isConnect && user && (user.organisation!==eglise?.number || region==='')){
      const query = new URLSearchParams({number: user.organisation}).toString();
      fetch(API.concat('/eglise?'+query), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token')
      }}).then(async response => {
        const token = response.headers.get('x-auth-token');
        if (response.status === 401) {
          sessionStorage.clear();
          updateConnect(false);
        } else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'));
          }
          if (response.status === 200) {
            const json = await response.json();
            setRegion(json.region[0]);
            sessionStorage.setItem('region', JSON.stringify(json.region[0]));
          }
        }
      })
    }
  },[user])

  useEffect(()=>{
    if(isConnect&& exercices.length===0&&user){
      getExercices(user.eglises.length>0 ? {eglise: {$in: user.eglises}} : {})
    }
  },[isConnect])

  return(
    <Context.Provider value={{ isConnect, updateConnect, eglise, setEglise, region, setRegion, exercice, setExercice, exercices, setExercices}} >
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <RouterProvider router={isConnect ? createBrowserRouter([{path:"/", element: <Home/>}, ...routes.filter(route=> user?.access.includes(route.path)||(user?.access.includes('/caisse')&&/^\/caisse\/.+$/.test(route.path))||route.path==='/journal/virements'||(route.path==='/journal/dons-inter-eglise'&&user?.access.includes('/journal/dons'))||(route.path==='/rapports/annuel'&&user?.access.includes('/rapports'))), {path:"*", element: <Home/>}]): unlogged_router}/>
        </React.StrictMode>
      </ThemeProvider>
    </Context.Provider>
  );

}